export default __webpack_public_path__ + "static/media/favourite.336c8f62.png";